package my.drivebit.web

import my.drivebit.utils.LEGACY_SHORT_BRAND_SEARCH_PATH_SLUGS

data class CityPathParts(
    val citySlug: String,
    val filterSlug: String? = null,
)

/**
 * First path segments handled by [my.drivebit.clients.App] — not city slugs.
 */
val RESERVED_FIRST_SEGMENTS: Set<String> =
    setOf(
        "create-car",
        "city-selection",
        "my-city-selection",
        "list-your-car",
        "verify-otp",
        "login-by-phone",
        "login-by-mail",
        "login-by-password",
        "signup",
        "profile",
        "my-cars",
        "my-bookings",
        "leave-review",
        "my-deals",
        "chats",
        "chat",
        "documents",
        "offer",
        "contacts",
        "privacy",
        "cookies",
        "payment",
        "payment-success",
        "payment-failure",
        "download-booking-contract",
        "inspection-act",
        "car-edit",
        "car-sts-upload",
        "car-photos-gallery",
        "car-photos-upload",
        "car-photos",
        "car-availability",
        "car-seasonal-pricing",
        "edit-name",
        "change-email",
        "change-phone",
        "change-password",
        "address-input",
        "license-plate-input",
        "car-brand-selection",
        "car-model-selection",
        "body-type-selection",
        "drive-type-selection",
        "engine-type-selection",
        "engine-volume-input",
        "production-year-input",
        "seats-count-input",
        "trunk-size-selection",
        "travel-destinations-selection",
        "daily-rate-input",
        "description-input",
        "passport-upload",
        "search",
        "car-detail",
    )

/**
 * Parses city URL path:
 * - `/city-slug`
 * - `/city-slug/filter-slug`
 */
fun parseCityPath(pathname: String): CityPathParts? {
    val pathOnly = pathname.substringBefore('?').substringBefore('#')
    val trimmed = pathOnly.trim().removePrefix("/").removeSuffix("/")
    if (trimmed.isEmpty()) return null
    val segments = trimmed.split('/').filter { it.isNotEmpty() }
    if (segments.size != 1 && segments.size != 2) return null
    val citySlug = segments[0].lowercase()
    if (citySlug in RESERVED_FIRST_SEGMENTS || citySlug in LEGACY_SHORT_BRAND_SEARCH_PATH_SLUGS) return null
    val filterSlug = segments.getOrNull(1)?.lowercase()
    // /{city}/search is the search screen, not a city filter landing
    if (filterSlug == "search") return null
    return CityPathParts(citySlug = citySlug, filterSlug = filterSlug)
}

fun parseCitySlugFromPath(pathname: String): String? = parseCityPath(pathname)?.citySlug

fun parseFilterSlugFromCityPath(pathname: String): String? = parseCityPath(pathname)?.filterSlug

fun isCityHomePath(pathname: String): Boolean {
    if (pathname.isEmpty() || pathname == "/") return true
    return parseCitySlugFromPath(pathname) != null
}
